export enum BetType {
    BJB_Split1_Start = 100, //For +seat = bettype use
    BJB1_Split1, //Seat bet
    BJB2_Split1,
    BJB3_Split1,
    BJB4_Split1,
    BJB5_Split1,
    BJB6_Split1,
    BJB7_Split1,

    BJBB_Split1_Start = 110, //Seat Bet Behind //For +seat = bettype use
    BJBB1_Split1,
    BJBB2_Split1,
    BJBB3_Split1,
    BJBB4_Split1,
    BJBB5_Split1,
    BJBB6_Split1,
    BJBB7_Split1,

    BJB_Pair_Start = 120, //Pair //For +seat = bettype use
    BJB1_Pair,
    BJB2_Pair,
    BJB3_Pair,
    BJB4_Pair,
    BJB5_Pair,
    BJB6_Pair,
    BJB7_Pair,

    BJB_Split2_Start = 130, //Seat Bet Split2 //For +seat = bettype use
    BJB1_Split2,
    BJB2_Split2,
    BJB3_Split2,
    BJB4_Split2,
    BJB5_Split2,
    BJB6_Split2,
    BJB7_Split2,

    BJB_DoubleDown_H1_Start = 140, //Seat Bet DoubleDown H1//For +seat = bettype use
    BJB1_DoubleDown_H1,
    BJB2_DoubleDown_H1,
    BJB3_DoubleDown_H1,
    BJB4_DoubleDown_H1,
    BJB5_DoubleDown_H1,
    BJB6_DoubleDown_H1,
    BJB7_DoubleDown_H1,

    BJB_DoubleDown_H2_Start = 150, //Seat Bet DoubleDown H2//For +seat = bettype use
    BJB1_DoubleDown_H2,
    BJB2_DoubleDown_H2,
    BJB3_DoubleDown_H2,
    BJB4_DoubleDown_H2,
    BJB5_DoubleDown_H2,
    BJB6_DoubleDown_H2,
    BJB7_DoubleDown_H2,

    BJBB_Split2_Start = 160, //Seat Bet Behind Split2 //For +seat = bettype use
    BJBB1_Split2,
    BJBB2_Split2,
    BJBB3_Split2,
    BJBB4_Split2,
    BJBB5_Split2,
    BJBB6_Split2,
    BJBB7_Split2,

    BJBB_DoubleDown_H1_Start = 170, //Seat Bet Behind DoubleDown //For +seat = bettype use
    BJBB1_DoubleDown_H1,
    BJBB2_DoubleDown_H1,
    BJBB3_DoubleDown_H1,
    BJBB4_DoubleDown_H1,
    BJBB5_DoubleDown_H1,
    BJBB6_DoubleDown_H1,
    BJBB7_DoubleDown_H1,

    BJBB_DoubleDown_H2_Start = 180, //Seat Bet Behind DoubleDown //For +seat = bettype use
    BJBB1_DoubleDown_H2,
    BJBB2_DoubleDown_H2,
    BJBB3_DoubleDown_H2,
    BJBB4_DoubleDown_H2,
    BJBB5_DoubleDown_H2,
    BJBB6_DoubleDown_H2,
    BJBB7_DoubleDown_H2,

    BJB_Insurant_Start = 190, //For +seat = bettype use
    BJB1_Insurant,
    BJB2_Insurant,
    BJB3_Insurant,
    BJB4_Insurant,
    BJB5_Insurant,
    BJB6_Insurant,
    BJB7_Insurant,

    BJBB_Insurant_Start = 200, //For +seat = bettype use
    BJBB1_Insurant,
    BJBB2_Insurant,
    BJBB3_Insurant,
    BJBB4_Insurant,
    BJBB5_Insurant,
    BJBB6_Insurant,
    BJBB7_Insurant,
}

export const BJ2MainBet = [
    BetType.BJB1_Split1,
    BetType.BJB2_Split1,
    BetType.BJB3_Split1,
    BetType.BJB4_Split1,
    BetType.BJB5_Split1,
    BetType.BJB6_Split1,
    BetType.BJB7_Split1,
];

export const BJ2PairBet = [
    BetType.BJB1_Pair,
    BetType.BJB2_Pair,
    BetType.BJB3_Pair,
    BetType.BJB4_Pair,
    BetType.BJB5_Pair,
    BetType.BJB6_Pair,
    BetType.BJB7_Pair,
];

export const BJ2BetBehind = [
    BetType.BJBB1_Split1,
    BetType.BJBB2_Split1,
    BetType.BJBB3_Split1,
    BetType.BJBB4_Split1,
    BetType.BJBB5_Split1,
    BetType.BJBB6_Split1,
    BetType.BJBB7_Split1,
];

export const BJ2CanRebet = [
    BetType.BJB1_Split1,
    BetType.BJB2_Split1,
    BetType.BJB3_Split1,
    BetType.BJB4_Split1,
    BetType.BJB5_Split1,
    BetType.BJB6_Split1,
    BetType.BJB7_Split1,
    BetType.BJBB1_Split1,
    BetType.BJBB2_Split1,
    BetType.BJBB3_Split1,
    BetType.BJBB4_Split1,
    BetType.BJBB5_Split1,
    BetType.BJBB6_Split1,
    BetType.BJBB7_Split1,
    BetType.BJB1_Pair,
    BetType.BJB2_Pair,
    BetType.BJB3_Pair,
    BetType.BJB4_Pair,
    BetType.BJB5_Pair,
    BetType.BJB6_Pair,
    BetType.BJB7_Pair,
];

export const BJ2SeatBet = [
    BetType.BJB1_Split1,
    BetType.BJB2_Split1,
    BetType.BJB3_Split1,
    BetType.BJB4_Split1,
    BetType.BJB5_Split1,
    BetType.BJB6_Split1,
    BetType.BJB7_Split1,
    BetType.BJB1_Split2,
    BetType.BJB2_Split2,
    BetType.BJB3_Split2,
    BetType.BJB4_Split2,
    BetType.BJB5_Split2,
    BetType.BJB6_Split2,
    BetType.BJB7_Split2,
    BetType.BJB1_DoubleDown_H1,
    BetType.BJB2_DoubleDown_H1,
    BetType.BJB3_DoubleDown_H1,
    BetType.BJB4_DoubleDown_H1,
    BetType.BJB5_DoubleDown_H1,
    BetType.BJB6_DoubleDown_H1,
    BetType.BJB7_DoubleDown_H1,
    BetType.BJB1_DoubleDown_H2,
    BetType.BJB2_DoubleDown_H2,
    BetType.BJB3_DoubleDown_H2,
    BetType.BJB4_DoubleDown_H2,
    BetType.BJB5_DoubleDown_H2,
    BetType.BJB6_DoubleDown_H2,
    BetType.BJB7_DoubleDown_H2,
];
